import { render, staticRenderFns } from "./StickerCard.vue?vue&type=template&id=93f0a706&scoped=true&"
import script from "./StickerCard.vue?vue&type=script&lang=ts&"
export * from "./StickerCard.vue?vue&type=script&lang=ts&"
import style0 from "./StickerCard.vue?vue&type=style&index=0&id=93f0a706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f0a706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
